import { render, staticRenderFns } from "./FerramentaEstudo.vue?vue&type=template&id=723317cd&scoped=true"
import script from "./FerramentaEstudo.vue?vue&type=script&lang=js"
export * from "./FerramentaEstudo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723317cd",
  null
  
)

export default component.exports